import { Box, Button, Card, Text } from '@wix/design-system';
import { useInstanceContext } from '../context/InstanceContext';
import { Favorite } from '@wix/wix-ui-icons-common';
import { redirectToUpgrade } from '../utils/logic';
import { FREE_CAMPAING_LIMIT, FREE_RESPONSE_LIMIT } from '../utils/shared/constants';

interface Props {
}

export default function TrialInfo(props: Props) {
    const { instanceData, instanceId } = useInstanceContext();


    if (!instanceData.instanceId || instanceData.planId) {
        return null;
    }

    return (
        <Card>
            <Card.Content>
                <Box gap={'24px'} direction='vertical' className='center'>

                    <Text>This app comes with {FREE_CAMPAING_LIMIT} free campaing and {FREE_RESPONSE_LIMIT} free responses.</Text>
                    <Button skin='premium' onClick={() => redirectToUpgrade(instanceId)} prefixIcon={<Favorite />}>
                        Upgrade
                    </Button>
                </Box>
            </Card.Content>
        </Card>
    );
}